export default class Resource {
    public constructor(
        private readonly id: number,
        private readonly name: string,
        private readonly description: string,
        private readonly uuid: string,
        private readonly entityChanged: number,
        private readonly lastVerified: number,
        private readonly timeLapse: number
    ) {}

    public getId(): number {
        return this.id;
    }

    public getName(): string {
        return this.name;
    }

    public getDescription(): string {
        return this.description;
    }

    public getUuid(): string {
        return this.uuid;
    }

    public getEntityChanged(): number {
        return this.entityChanged;
    }

    public getLastVerified(): number {
        return this.lastVerified;
    }

    public getTimeLapse(): number {
        return this.timeLapse;
    }
}